(() => {
  // '12-x-8', '24-x-16', '30-x-20', '36-x-24', '39-x-26', '45-x-30', '48-x-32', '51-x-34'
  const productTypeSizes = {
    // 8" × 12" / 12" × 8" - '12-x-8'
    // 16" × 24" / 24" × 16" - '24-x-16'
    // 20" × 30" / 30" × 20" - '30-x-20'
    // 24" × 36" / 36" × 24" - '36-x-24'
    // 26" × 39" / 39" × 26" - '39-x-26'
    // 30" × 45" / 45" × 30" - '45-x-30'
    // 32" × 48" / 48" × 32" - '48-x-32'
    // 34" × 51" / 51" × 34" - '51-x-34'
    "gallery-wrapped-canvas": ['12-x-8', '24-x-16', '30-x-20', '36-x-24', '39-x-26', '45-x-30', '48-x-32', '51-x-34'],

    // 16" × 12" / 12" × 16" - '16-x-12'
    // 19" × 14" / 14" × 19" - '19-x-14'
    // 22" × 16" / 16" × 22" - '22-x-16'
    // 28" × 20" / 20" × 28" - '28-x-20'
    // 31" × 22" / 22" × 31" - '31-x-22'
    // 34" × 24" / 24" × 34" - '34-x-24'
    // 40" × 28" / 28" × 40" - '40-x-28'
    // 46" × 32" / 32" × 46" - '46-x-32'

    // 18" × 14" / 14" × 18" - '18-x-14'
    // 21" × 16" / 16" × 21" - '21-x-16'
    // 24" × 18" / 18" × 24" - '24-x-18'
    // 30" × 22" / 22" × 30" - '30-x-22'
    // 33" × 24" / 24" × 33" - '33-x-24'
    // 36" × 26" / 26" × 36" - '36-x-26'
    // 42" × 30" / 30" × 42" - '42-x-30'
    // 45" × 32" / 32" × 45" - '45-x-32'
    "fine-art-photo-print": ['16-x-12', '19-x-14', '22-x-16', '28-x-20', '31-x-22', '34-x-24', '40-x-28', '46-x-32'],

    // 18" × 14" / 14" × 18" - '18-x-14'
    // 21" × 16" / 16" × 21" - '21-x-16'
    // 24" × 18" / 18" × 24" - '24-x-18'
    // 30" × 22" / 22" × 30" - '30-x-22'
    // 33" × 24" / 24" × 33" - '33-x-24'
    // 36" × 26" / 26" × 36" - '36-x-26'
    // 42" × 30" / 30" × 42" - '42-x-30'
    // 45" × 32" / 32" × 45" - '45-x-32'
    "black-frame-fine-art-photo-print": ['18-x-14', '21-x-16', '24-x-18', '30-x-22', '33-x-24', '36-x-26', '42-x-30', '45-x-32'],

    // 18" × 14" / 14" × 18" - '18-x-14'
    // 21" × 16" / 16" × 21" - '21-x-16'
    // 24" × 18" / 18" × 24" - '24-x-18'
    // 30" × 22" / 22" × 30" - '30-x-22'
    // 33" × 24" / 24" × 33" - '33-x-24'
    // 36" × 26" / 26" × 36" - '36-x-26'
    // 42" × 30" / 30" × 42" - '42-x-30'
    // 45" × 32" / 32" × 45" - '45-x-32'
    "white-frame-fine-art-photo-print": ['18-x-14', '21-x-16', '24-x-18', '30-x-22', '33-x-24', '36-x-26', '42-x-30', '45-x-32'],

    // 12" × 8" / 8" × 12" - '12-x-8'
    // 18" × 12" / 12" × 18" - '18-x-12'
    // 24" × 16" / 16" × 24" - '24-x-16'
    // 30" × 20" / 20" × 30" - '30-x-20'
    // 36" × 24" / 24" × 36" - '36-x-24'
    // 45" × 30" / 30" × 45" - '45-x-30'
    "adhesive-poster": ['12-x-8', '18-x-12', '24-x-16', '30-x-20', '36-x-24', '45-x-30'],
  }

  document.addEventListener('DOMContentLoaded', () => {
    const conditionalContainer = document.querySelector('.product-form__input.conditional');

    if (!conditionalContainer) {
      return;
    }

    const conditionalTitle = conditionalContainer.querySelector('.conditional--options--title');
    const conditionalTriggers = conditionalContainer.querySelectorAll('.conditional--trigger');
    const conditionalOptions = conditionalContainer.querySelectorAll('.conditional--option');
    const topLevelConditionalOptions = conditionalContainer.querySelectorAll('.conditional--option.top-level');
    const printLevelConditionalOptions = conditionalContainer.querySelectorAll('.conditional--option.prints');
    const sizeOptionsContainer = document.querySelector('.product-form__input[data-handle="size"]');

    const atcButton = document.querySelector('.single-add-to-cart-button');
    const dynamicButton = document.querySelector('.shopify-payment-button');

    if (!conditionalTriggers || !conditionalOptions || !conditionalTitle || !sizeOptionsContainer) {
      console.log("Malik -- Conditional elements not found");
      return;
    }

    resetOptions();

    conditionalTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const ignoredTrigger = trigger.id === 'framed--conditional' ? 'prints--conditional' : false;

        triggerConditionalGroup(trigger, ignoredTrigger);
      });
    })

    conditionalOptions.forEach(option => {
      option.addEventListener('click', () => {
        handleOptionClick(option);
      });
    })

    // Select the first option by default
    conditionalOptions[0].click();

    if (topLevelConditionalOptions) {
      topLevelConditionalOptions.forEach(option => {
        option.addEventListener('click', removeConditionalClasses);
      });
    }

    if (printLevelConditionalOptions) {
      printLevelConditionalOptions.forEach(option => {
        option.addEventListener('click', () => {
          const trigger = conditionalContainer.querySelector('#prints--conditional.conditional--trigger');

          triggerConditionalGroup(trigger);
          handleOptionClick(option);
        });
      });
    }

    function enableATC() {
      if (atcButton) {
        atcButton.disabled = false;
      }

      if (dynamicButton) {
        dynamicButton.style.display = 'block';
      }
    }

    function disableATC() {
      if (atcButton) {
        atcButton.disabled = true;
      }

      if (dynamicButton) {
        dynamicButton.style.display = 'none';
      }
    }

    function resetOptions() {
      disableATC();

      removeConditionalOptionClasses();

      if (sizeOptionsContainer) {
        sizeOptionsContainer.style.display = 'none';
      }

      conditionalOptions.forEach(option => {
        const optionInput = option.querySelector('input[type="radio"]');

        optionInput.checked = false;
      })
    }

    function triggerConditionalGroup(trigger, ignoredTrigger = false) {
      const triggeredClass = trigger.dataset.triggeredClass || 'prints-active';
      const triggeredGroup = trigger.dataset.triggeredGroup || 'prints';
      const activeTitle = trigger.dataset.activeTitle || 'Choose Product:';

      let is_first_clicked = false;

      removeConditionalClasses(ignoredTrigger);
      resetOptions();

      // conditionalTitle.textContent = activeTitle;
      trigger.classList.add('active');
      conditionalContainer.classList.add(triggeredClass);

      if (conditionalOptions) {
        conditionalOptions.forEach(option => {
          if (!is_first_clicked && option.classList.contains(triggeredGroup)) {
            // option.querySelector('label').dispatchEvent(new MouseEvent('click', { view: window, bubbles: true }));

            is_first_clicked = true;
          }
        })
      }
    }

    function handleOptionClick(option) {
      const handle = option.dataset.handle;
      const sizeOptions = sizeOptionsContainer.querySelectorAll('.option');
      const sizes = productTypeSizes[handle];
      const optionInput = option.querySelector('input[type="radio"]');
      const conditionalAccordion = document.querySelector(`.conditional_accordion[data-handle="${handle}"]`);

      let is_first_clicked = false;

      removeConditionalOptionClasses();

      if (conditionalAccordion) {
        conditionalAccordion.classList.add('active');
      }

      optionInput.checked = true;

      if (sizeOptionsContainer) {
        sizeOptionsContainer.style.display = 'flex';
      }

      if (atcButton) {
        atcButton.disabled = false;
      }

      if (dynamicButton) {
        dynamicButton.style.display = 'block';
      }

      if (sizeOptions) {
        // console.log('malik -- sizeOptions', sizeOptions);

        // Array.from(sizeOptions).some(sizeOption => {
        //   // console.log('malik -- sizeOption' + sizeOption.dataset.handle, window.getComputedStyle(sizeOption).display);
        //
        //   if (window.getComputedStyle(sizeOption).display !== 'none') {
        //     console.log("malik -- ", sizeOption.dataset.handle, " --- ", sizeOption.querySelector('label'), '---', window.getComputedStyle(sizeOption).display);
        //
        //     sizeOption.querySelector('label').dispatchEvent(new MouseEvent('click', { view: window, bubbles: true }));
        //
        //     return true;
        //   }
        // })

        sizeOptions.forEach(sizeOption => {
          const sizeHandle = sizeOption.dataset.handle;

          if (sizes.includes(sizeHandle)) {
            sizeOption.classList.add('active');

            if (!is_first_clicked) {
              sizeOption.querySelector('label').dispatchEvent(new MouseEvent('click', { view: window, bubbles: true }));
              is_first_clicked = true;
            }
          }
        })
      }

      option.classList.add('active');
      sizeOptionsContainer.classList.add(handle);
    }

    function removeConditionalClasses(ignore = false) {
      conditionalTriggers.forEach(trigger => {
        if (ignore && trigger.id === ignore) {
          return;
        }

        const triggeredClass = trigger.dataset.triggeredClass || 'prints';

        trigger.classList.remove('active');

        conditionalContainer.classList.remove(triggeredClass);
      });
    }

    function removeConditionalOptionClasses() {
      conditionalOptions.forEach(option => {
        const handle = option.dataset.handle;
        const sizeOptions = sizeOptionsContainer.querySelectorAll('.option');
        const conditionalAccordion = document.querySelector(`.conditional_accordion[data-handle="${handle}"]`);

        if (conditionalAccordion) {
          conditionalAccordion.classList.remove('active');
        }

        option.classList.remove('active');
        sizeOptionsContainer.classList.remove(handle);

        sizeOptions.forEach(sizeOption => {
          sizeOption.classList.remove('active');
        })
      });
    }
  })
})();
